import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';


export const createBranch = createAsyncThunk(
    'branch/createbranch',
    async (data: any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/branch', data);         
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create branch');
      }
    }
  );

export const UpdateBranch = createAsyncThunk<any , {Id: number; data: any}, { rejectValue: string }>(
    'branch/updatebranch',
    async ({Id , data}: {Id : Number; data: Partial<any>}, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/branch/${Id}`, data)
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to Update Branch');
      }
    }
  ); 

export const fetchBranchById = createAsyncThunk(
    'branch/getbranchById',
    async (Id: any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.get(`/branch/${Id}`);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create branch');
      }
    }
  );

export const deletebranchById = createAsyncThunk(
    'branch/deletebranch',
    async ( Id: any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.delete(`/branch/${Id}`);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to delete branch');
      }
    }
  );

export const fetchAllBranch = createAsyncThunk(
    'branch/fetchall',
    async (_, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.get('/branch');          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to Fetch Branch');
      }
    }
  );